'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import VidyardVideoPlayer from 'ui-addon-video-player/components/VidyardVideoPlayer';
export default (function (_ref) {
  var handleClose = _ref.handleClose,
      ctaLink = _ref.ctaLink;
  return /*#__PURE__*/_jsxs("div", {
    className: "modal display-block",
    children: [/*#__PURE__*/_jsx("div", {
      className: "close-container",
      children: /*#__PURE__*/_jsx("a", {
        className: "close",
        onClick: handleClose
      })
    }), /*#__PURE__*/_jsxs("section", {
      className: "modal-main",
      children: [/*#__PURE__*/_jsx(VidyardVideoPlayer, {
        videoId: "nT2dPi7dvcXfoMxUSCDkif"
      }), /*#__PURE__*/_jsxs("div", {
        className: "video-cta-footer",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "video-cta-banner",
          children: [/*#__PURE__*/_jsx("div", {
            className: "title",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "videoHero.title"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "description",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "videoHero.description"
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "video-cta-button",
          children: /*#__PURE__*/_jsx("a", {
            className: "button white",
            href: ctaLink,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "videoHero.button"
            })
          })
        })]
      })]
    })]
  });
});